export const MESSAGE_TIMEOUT_MS = 15000;
export const RETRY_CONNECTION_MS = 5000;